import Glide from '@glidejs/glide';
import './blocks/need-help';

const glideInit = (element, config) => {
    if ($(element).length) {

        if ($(element).find('.glide__slide').length) {

            return new Glide(element, config).mount();
        }
    }
};

const slider_add_class_running = (slider_glide_object, slider_container) => {
    const class_running = 'hh-slider-running';

    slider_glide_object.on('move', function() {
        $(slider_container).addClass(class_running);
    });

    slider_glide_object.on('move.after', function() {
        $(slider_container).removeClass(class_running);
    });
};

$(document).ready(() => {
    glideInit('.hh-photo-slider', {
        perView: 1
    });

    glideInit('.hh-video-slider', {
        perView: 2,
        type: 'carousel',
        breakpoints : {
            1023: {
                perView: 1,
            },
        },
    });

    glideInit('.hh-question-to-priest__slider', {
        perView: 1
    });

    $('.hh-post-slider').each((index, element) => {
        glideInit(element, {
            perView: 1
        });
    });
});

// Слайдер для блока "Выбор редакции"
$(document).ready(() => {
    if (! $('.hh-editor-choice-slider').length) {
        return;
    }

    const slider_container = '.hh-home-template__editors-choose';

    const glide_editor_choice = new Glide('.hh-editor-choice-slider', {
        perView: 4,
        startAt: 0,

        type: 'carousel',
        gap: 24,
        breakpoints: {
            1023: {
                perView: 1,
            }
        },
    });

    slider_add_class_running(glide_editor_choice, slider_container);

    if ($(glide_editor_choice.selector).find('.glide__slide').length) {
        glide_editor_choice.mount();
    }
});

// Отдельная логика для слайдера "Материалы по теме"
$(document).ready(() => {
    if (! $('.js-topics-slider').length) {
        return;
    }

    $('.js-topics-slider').each((index, element) => {

        // количество слайдов зависит от окружения, куда вставлен слайдер
        let slidesCount = 4;
        const parents = $(element).parents('.hh-article-container__materials-on-topic');

        if (parents.filter('.hh-article-container__materials-on-topic_incontent').length) {
            slidesCount = 3;
        }

        const glide_topics = new Glide(element, {
            startAt: 0,
            perView: slidesCount,
            type: 'carousel',
            gap: 24,
            breakpoints : {
                1023: {
                    perView: 1
                }
            }
        });

        if ($(glide_topics.selector).find('.glide__slide').length) {
            glide_topics.mount();
        }
    });
});


